'use client';

import React from 'react';
import { Category } from '@/data/resources';
import ResourceCard from './ResourceCard';
import { getColorFromString } from '@/lib/utils';
import { useTranslation } from '@/hooks/useTranslation';

interface CategorySectionProps {
  category: Category;
}

const CategorySection = ({ category }: CategorySectionProps) => {
  const accentColor = getColorFromString(category.name);
  const { t } = useTranslation();
  
  return (
    <section id={category.id} className="mb-12 pt-4 scroll-mt-16">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center">
          {t(category.id)}
        </h2>
        <div className={`mt-1 h-1 w-20 rounded ${accentColor}`}></div>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {category.resources.map((resource) => (
          <ResourceCard key={resource.id} resource={resource} />
        ))}
      </div>
    </section>
  );
};

export default CategorySection; 